(ns teamoesterreich.admin-mode.toe-map-list.toe-map-list
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [reagent.core :as r]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.toe-map-list.maps-element :as maps-element]
            [teamoesterreich.admin-mode.toe-map-list.small-toe-table :as small-toe-table]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.data.user :as s-user]))



(defn event-value
  [^js/Event e]
  (h/event-value e))


(defn update-list [!st & [search filter sort]]
  ;(js/console.log "update-list " @!search @!filter)
  (s-user/get-user-list-elements
    {:srch                search
     :srch-add-fields     {:tomId true :name true :email true :phone true :geo true}
     :filter-status       (:filter-status filter) :filter-organizationDepartment (:filter-organizationDepartment filter)
     :filter-organization (:filter-organization filter) :filter-toe-active (:filter-toe-active filter)

     :sort                sort
     }
    (fn [data]
      (swap! !st assoc
             :loaded true
             :count (get data "cnt")
             :elems (get data "rows")))
    ))



(defn filter-pane [!st]
  (let [!filter (r/cursor !st [:filter])
        !search (r/cursor !st [:search])
        !sort (r/cursor !st [:sort])]
    [mui/paper
     [mui/grid
      {:container  true
       :direction  "row"
       :alignItems "flex-start"
       :justify    "flex-start"
       :spacing    1
       :style      {:padding "5px"}
       }


      [mui/grid
       {:item true
        :md   6
        :xs   6
        }
       [org-selector/get-selector !filter #(update-list !st @!search @!filter @!sort) (d-rights/get-rights-orgId-filter d-rights/USER_SEARCH)]
       ]


      [mui/grid
       {:item true
        :md   2
        :xs   2
        }
       ;[mui/form-control-label {:label     (r/as-element [mui/typography {:style {:fontSize "0.8rem" :color "#888"}} "Sperre/Auszeit anzeigen"])
       ;                         :value     ""
       ;                         :placement "start"
       ;                         :control   (r/as-element [mui/checkbox {}])}]
       ]]]
    ))


(defn render [!st]
  (let [!elems (r/cursor !st [:elems])
        !search (r/cursor !st [:search])
        !filter (r/cursor !st [:filter])
        !sort (r/cursor !st [:sort])
        !count (r/cursor !st [:count])
        !map-userPopup (r/cursor v-state/app-state [:toe-map :activeUserPopup])
        !waiting? (atom false)
        ]
    (js/console.log "Mount toe-map-list " @!search @!filter @!sort)
    (let [cnt-rows @!count]
      [mui/grid
       {:container true
        :direction "row"
        :spacing   3
        :justify   "center"
        :style     {:marginTop "10px"}
        }
       [toe-modal/get-modal !map-userPopup]
       [mui/grid {:item true
                  :xs   12
                  }

        [filter-pane !st]
        ;"Wichtigste Filter hier rein: Min-Status (def: alle Valid), Sperrtext, Auszeit"
        ]
       [mui/grid
        {:item   true
         :height 500
         :xs     12
         :sm     8
         }
        [maps-element/map-home !st]
        ]
       [mui/grid
        {:item   true
         :height 500
         :xs     12
         :sm     4
         }
        [mui/paper
         [:div {:style #js {:height "70px"}}
          [mui/text-field
           {:default-value (str @!search)
            :placeholder   "suche..."
            :style         {:float "left" :margin "0 5px 5px 5px" :display "inline-block"}
            :helper-text   "Freitextsuche in [Name, Email, Tel, TomId]"
            :onChange      (h/wait-do !waiting? (fn [val]
                                                  (swap! !st assoc :search val)
                                                  (update-list !st @!search @!filter)))
            :multiline     false}]
          [:div {:style {:width "60px" :marginTop "20px" :display "inline-block"}} "Gefunden: " cnt-rows]
          ]
         (if (empty? @!elems)
           [mui/paper [:h3 "Keine Ergebnisse gefunden!"]]
           [small-toe-table/autoSizer-table !st]
           )]]])))


(defn get-it []
  (js/console.log "Mount toe-map ")
  (let [!st (r/cursor v-state/app-state [:toe-map :map-list-state])
        !loaded? (r/cursor !st [:loaded])
        ]
    ;!st (r/atom {:elms {} :sort "lastName" :reverse true :search "" :center-map {} :selected nil :filter {:filter-status "*" :filter-organizationDepartment []}})]
    (if (not @!loaded?)
      (do
        (update-list !st)
        [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."])
      [render !st])))